import widgetTransformer from '@nykaa/deals-transformer';

import { ApiHelper } from '@nykaa/utils/network';
import { logger } from '@nykaa/logger';
import { getAdPlatformApi } from './helper';
import { queryStringFromParams } from 'shared/helpers/utils/url';


export const getWidgets = async ( queryParams: any, pagePrefix?: string ) => {
  const url = getAdPlatformApi();
  const queryString = queryStringFromParams(queryParams);

  try {
    const { data: { result } } = await ApiHelper(`${url}${queryString}`, 'get');
    if (!result) {
      throw new Error('"result" not found in widgets api -> data');
    }

    const transformedData = widgetTransformer(result, true, __PLATFORM__, pagePrefix);

    return transformedData.widgets;
  } catch (e) {
    logger.error(e, 'Error fetching widgets');
    throw e;
  }
};
